module.exports = __webpack_public_path__ + "c2348978471510a4da81a4c3375cc7c5.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/brokerage.png
// module id = 708
// module chunks = 0